import HotelList from "../../components/Hotel/Hotel";
import WhatsAppRedirect from "../../components/Whatsapp/Whatsapp";

const Hotels = () => {
  return (
    <div className="mt-5">
      <HotelList />
      <div className="fixed bottom-8 right-8">
        <WhatsAppRedirect />
      </div>
    </div>
  );
};

export default Hotels;
